var InputBase = require('../base');
var defaultOptions = {
  url: '/file/upload',
};

var Uploader = InputBase.extend( {
  create: function( options, $container ) {
    var $inp = $( '<input name="fileUrl" type="hidden"/>' );
    var config = {};
    for(var key in defaultOptions) {
      config[key] = defaultOptions[key];
    }
    for(var key in options) {
      config[key] = options[key];
    }

    var upload = $('<span></span>');
    var tip = $('<span></span>');

    $container.append(upload).append(tip).append($inp);
    config['add'] = function (e, data) {
      tip.show().html('uploading...');
      $inp.val('');
      var jqXHR = data.submit()
        .success(function (result, textStatus, jqXHR) {
          if (result.success) {
            var file = result.data.files[0];
            tip.show().html('<a href="/file/'+file.url+'" target="_blank">'+file.originalFilename+'</a>');
            $inp.val(file.url);
          } else {

          }
        })
        .error(function (jqXHR, textStatus, errorThrown) {
          tip.show().html('<span style="color:red">'+errorThrown+'</span>');
        });
    }

    Enhancer.registerFileUpload(upload, config);

    return $inp;
  }
});

module.exports = Uploader;


//////////////////
// WEBPACK FOOTER
// ./src/input-factory/uploader/index.js
// module id = 21
// module chunks = 0